"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtensionHelper = void 0;
var map_creator_1 = require("../../../base-utils/map-creator");
var ExtensionHelper = (function () {
    function ExtensionHelper() {
    }
    ExtensionHelper.convertExtensionToMimeType = function (ext) {
        var mimeType = ExtensionHelper.extToMimeType[ext.toLowerCase()];
        return mimeType ? mimeType : 'image/png';
    };
    ExtensionHelper.convertMimeTypeToExtension = function (mimeType) {
        var ext = ExtensionHelper.mimeToExt[mimeType.toLowerCase()];
        return ext ? ext : 'png';
    };
    ExtensionHelper.makeBase64UriPrefix = function (mimeType) {
        return "data:" + mimeType + ";base64,";
    };
    ExtensionHelper.getBase64DataWithoutPrefix = function (base64uri) {
        var match = base64uri.match(/data\:.*\;base64,/);
        return match ? base64uri.substr(match[0].length) : base64uri;
    };
    ExtensionHelper.getMimeTypeFromBase64Uri = function (prefix) {
        var match = prefix.match(/data\:(.*)\;base64,/);
        return match && match[1] ? match[1].toLowerCase() : 'png';
    };
    ExtensionHelper.extToMimeType = new map_creator_1.MapCreator()
        .add('png', 'image/png')
        .add('jpeg', 'image/jpeg')
        .add('jpg', 'image/jpeg')
        .add('svg', 'image/svg+xml')
        .add('gif', 'image/gif')
        .get();
    ExtensionHelper.mimeToExt = new map_creator_1.MapCreator()
        .add('image/png', 'png')
        .add('image/jpeg', 'jpeg')
        .add('image/svg+xml', 'svg')
        .add('image/gif', 'gif')
        .get();
    return ExtensionHelper;
}());
exports.ExtensionHelper = ExtensionHelper;
